import { forwardRef, useState, useEffect, ChangeEvent } from 'react';
import { theme } from '@frontend/theme';
import { FieldChangeEvent } from '../hooks';
import { Input } from './input.component';
import type { InputProps } from './types';

export const DateNavigatorInput = forwardRef<HTMLInputElement, InputProps<'text'>>(
  ({ value = '', onChange, ...rest }, ref) => {
    // Local state is used to allow typing spaces at end of the input string
    // which gets trimmed while getting value from `useForm` or `useFormField`.
    // We need it to enter dates like "Jan 21" or "next week" etc.
    const [localValue, setLocalValue] = useState<string>(value);

    const handleChange = (event?: FieldChangeEvent) => {
      setLocalValue((event as ChangeEvent<HTMLInputElement>).target.value);
      onChange(event);
    };

    // Sync local value when prop value changes
    useEffect(() => {
      setLocalValue(value || '');
    }, [value]);

    return (
      <Input
        type='text'
        value={localValue}
        style={{ fontSize: theme.fontSize(12) }}
        onChange={handleChange}
        ref={ref}
        {...rest}
      />
    );
  }
);

DateNavigatorInput.displayName = 'DateNavigatorInput';
